import facets from './facetsSlice';
import make from './make/makeSlice';

const root = {
	facets,
	make
};

export default root;
